// The bobbin question's part_type rules, in ONE place so the legacy ChooseLayoutDimensions row and Frank's
// unified section-filter row default, force, and hide it identically (issue #5311, A1):
//   - carton              -> shown, starts UNCHECKED, editable
//   - carton_lamination   -> shown, starts CHECKED, editable
//   - corrugated flexo / flexo_on_carton -> shown, FORCED on and cannot be unchecked (always made on a bobbin)
//   - corrugated_cardboard_offset        -> hidden entirely
const FLEXO_PART_TYPES = ['corrugated_cardboard_flexo', 'corrugated_cardboard_flexo_on_carton'];

export const bobbinGating = (partType) => {
  const shown = partType != undefined && partType !== 'corrugated_cardboard_offset';
  const forced = FLEXO_PART_TYPES.includes(partType);
  const defaultEnabled = forced || partType === 'carton_lamination';
  return { shown, forced, defaultEnabled };
};

export default bobbinGating;
